import { render, staticRenderFns } from "./CustomerLogin.vue?vue&type=template&id=3908390c&scoped=true&"
var script = {}
import style0 from "./CustomerLogin.vue?vue&type=style&index=0&id=3908390c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908390c",
  null
  
)

export default component.exports